module.exports = __webpack_public_path__ + "fonts/Rubik-MediumItalic.56ed0c74.ttf";